import { render, staticRenderFns } from "./TwTable.vue?vue&type=template&id=63c330d4&scoped=true&"
import script from "./TwTable.vue?vue&type=script&lang=js&"
export * from "./TwTable.vue?vue&type=script&lang=js&"
import style0 from "./TwTable.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TwTable.vue?vue&type=style&index=1&id=63c330d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c330d4",
  null
  
)

export default component.exports